



























































































































































































































import { Component, Watch } from 'vue-property-decorator';
import BaseFormEdit from '../../models/base.form.edit';
import Donor from '../../models/donor';
import axios from 'axios';
import Swal from 'sweetalert2';
import { EventBus } from '@/event-bus';
import FormHelper from '@/helpers/form.helper';

@Component({})
export default class Edit extends BaseFormEdit {
  form:any = new Donor();

  isDictionary: boolean = false;
  inaccessibility: any = null;
  inaccessibilityReasons: any = [];
  isGridRecieved: boolean = true;

  get title() {
    return this.form.isNew ? this.$t('Добавление донора') + '' : this.$t('Донор') + ` IDD ${this.form.idd || ''}`;
  }
  
  get hasIon() {
    return window.ion;
  }

  get canEditGrid() {
    return (
      this.$auth.user().functions.find((t: any) => t.routeName === "EditDonorGrid") != null
    );
  }

  donorNumberFormatter(e :any) {
    return String(e).substring(0,13);
  }

  async submitWithValidation(path: any, isGoBack = false) { 
      if(!FormHelper.hlaValidCount(this.form.hlas)) {        
        Swal(
          this.$t('Предупреждение') + '',
          this.$t('Нельзя сохранить донора без указания минимум одного локуса') + '',
          'warning'
        );
        return;
      }
      if(this.form.isTemporaryInaccessible || !this.form.inaccessibilityName) {
        await this.submit(path, isGoBack);
      } else {
        EventBus.$emit('showThrobber');
        await axios
          .get(`/Donors/IsDonorAtWork?id=${this.form.id}`)        
          .then((response) => {
            if(response.data) {
              const div = document.createElement("div");
              div.innerHTML = `<p><b>` + this.$t('Донор участвует в работе') + `</b></p>
                               <p>` + this.$t('Установка данной причины недоступности удалит этого донора из работы') + `</p>
                               <h3>` + this.$t('Продолжить?') + `</h3>`;
              //@ts-ignore
              this.$swal({
                icon: 'warning',
                title: this.$t('Предупреждение'),
                content: div,
                buttons: [this.$t('Нет'), this.$t('Да')],
              }).then((willDelete: any) => {
                if (willDelete) {
                  this.submit(path, isGoBack);
                }
              });
            } else {
              this.submit(path, isGoBack);
            }
          })
          .catch(e => {
            EventBus.$emit('error', { msg: e.data.message });
          })
          .finally(() => {
            EventBus.$emit('hideThrobber'); 
          }); 
      } 
  }

  @Watch('form.externalId')
  onExternalIdChange()
  {
    if(this.isDataLoaded && this.form.isNew && this.hasIon)
    {
      EventBus.$emit('showThrobber');
      axios.get(`/Donors/GetGridFromExternalId?externalId=${this.form.externalId}&organizationId=` + this.$auth.user().currentOrganization.id)
      .then(response => {
        this.form.grid = response.data.grid;
        this.isGridRecieved = true;
      })
      .catch(() => {
        EventBus.$emit('error', { msg: this.$t('Ошибка получения `Код донора GRID` с сервера') });
        this.isGridRecieved = false;
      })
      .finally(() => {
        EventBus.$emit('hideThrobber'); 
      });
    }
  }

  @Watch('isDictionary')
  onIsDictionaryChange()
  {
    if(!this.isDictionary)
    {
      this.clearInaccessibility();
    }
  }

  @Watch('isDataLoaded')
  onIsDataLoaded() 
  {
    if(this.isDataLoaded)
    {
      this.isDictionary = this.form.inaccessibilityCode != "Another";     
      this.inaccessibilityReasons = this.form.inaccessibilityReasons
                                    .map((x: any) => ({ key: x.code, value: x.name, isTemporary: x.isTemporary }));
      this.inaccessibility = this.inaccessibilityReasons.find((x: any) => x.key == this.form.inaccessibilityCode);
    }
  }

  get inaccessibilityReasonOptions() {    
    if (!this.form.inaccessibilityReasons) {
      return [];      
    }   

    var another = { group: '', groups: this.inaccessibilityReasons.filter((x: any) => x.key == 'Another') };
    var temporary = { group: this.$t('Временные'), groups: this.inaccessibilityReasons.filter((t: any) => t.isTemporary && t.key != 'Another') };
    var permanent = { group: this.$t('Постоянные'), groups: this.inaccessibilityReasons.filter((t: any) => !t.isTemporary && t.key != 'Another' ) };    

    var reasons = [temporary, permanent, another]
    return reasons;
  }

  onInaccessibilityChange(val: any) { 
    this.inaccessibility = val;
    this.form.isTemporaryInaccessible = false;
    if(!val) 
    {
      this.form.inaccessibilityCode = null;
      this.isDictionary = false;
      this.clearInaccessibility();
      return;
    } 

    this.form.inaccessibilityCode = val.key;

    var inaccessibilityReason = this.form.inaccessibilityReasons.find((t: any) => t.code == val.key);
    this.isDictionary = inaccessibilityReason.code != "Another";

    if(this.isDictionary)
    {
      this.form.isTemporaryInaccessible = inaccessibilityReason.isTemporary;    
      this.form.inaccessibilityName = inaccessibilityReason.name;
    }
  }

  clearInaccessibility() {
    this.form.inaccessibilityName = '';
    this.form.inaccessibilityNote = '';
    this.form.inaccessibilityStatusDate = null;
  }
}
